import PageLayout from "@/components/layout/PageLayout";
import Problem from "@/components/sections/Problem";

export default function ProblemPage() {
  return (
    <PageLayout testId="problem-page">
      <Problem />
    </PageLayout>
  );
}
